
import validator from 'validator';

const validateCreateCoupon = (data) => {
    let errors = {};

    const { title,cCode,file} = data;

    if (validator.isEmpty(title)) {
        errors.title = 'Please Enter Title';
    }
    if (validator.isEmpty(cCode)) {
        errors.cCode = 'Please Enter coupon Code';
    }
    // if (validator.isEmpty(sdate)) {
    //     errors.sdate = 'select coupon start date';
    // }
    // if (validator.isEmpty(edate)) {
    //     errors.edate = 'select coupon end date';
    // }
    if (validator.isEmpty(file)) {
        errors.file = 'select your coupon image';
    }
    // if (!validator.isURL(link)) {
    //     errors.link = '유효하지 않은 URL입니다';
    // }
    // if (validator.isEmpty(file)) {
    //     errors.file = '파일을 업로드 해주세요';
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateCreateCoupon;
